var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('base-layer-panel',{on:{"changeLayer":_vm.changeLayer}}),(_vm.maptype!==null)?_c('base-map',{attrs:{"maptype":_vm.maptype}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }